export default __webpack_public_path__ + "static/media/6.9b1b4047.png";